import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Api } from "../../utils/api";

class EntityGroupsListTable extends React.Component {
  constructor() {
    super();
    this.goTo = this.goTo.bind(this);
    this.api = new Api();
  }

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  render() {
    const { entity_groups } = this.props;

    return (
      <div className="main-reqlist-container">
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left" width="100px">
                  ID
                </TableCell>
                <TableCell align="left" width="600px">
                  Nome
                </TableCell>
                <TableCell align="left" width="400px">
                  Super Utilizador
                </TableCell>
                <TableCell align="left">Email associado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entity_groups &&
                entity_groups.map((entity_group) => (
                  <TableRow
                    key={entity_group.id}
                    className="hand"
                    onClick={() =>
                      this.goTo(`/entity_groups/${entity_group.id}`)
                    }
                  >
                    <TableCell align="left">{entity_group.id}</TableCell>
                    <TableCell align="left">{entity_group.name}</TableCell>
                    <TableCell align="left">
                      {entity_group.super_user}
                    </TableCell>
                    <TableCell align="left">{entity_group.email}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
});

EntityGroupsListTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(EntityGroupsListTable));
